import { Injectable } from '@angular/core';
import { BaseResponseDto, GetTimezoneFilter, TimezoneListDto } from '@aoe/client';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class TimezoneService extends ApiService {

  getTimezone(req?: GetTimezoneFilter) {
    return this.get<BaseResponseDto<TimezoneListDto>>('timezone', req)
  }
}
